import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';

const submissionsKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'submissions'] as const,
    export: [...keys, 'submissions', 'export'] as const,
    id: <U extends QueryKeyParam>(itemId: U) =>
      createQueryKey({
        all: [...keys, 'submissions', itemId] as const,
        detail: [...keys, 'submissions', itemId, 'detail'] as const,
      }),
  });

export { submissionsKeys };
